import { render } from "./cancelClaimModal.vue?vue&type=template&id=07287de7"
import script from "./cancelClaimModal.vue?vue&type=script&lang=js"
export * from "./cancelClaimModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__